import React from 'react';
import icon from 'assets/images/softwares/PCP1.png';

const Icon = ({ width }) => <img src={icon} alt="PCP" width={width || '25'} />;

export default Icon;
